import { CustomerJourneyDetail } from "../types/welcomejourney/CustomerJourneyDetail";
import { axiosWithAuth } from "../utils/customAxios";
import { JourneyState } from "../types/welcomejourney/JourneyState";
import { RecordingNetworkAccessibilty } from "../types/master-data";

const welcomejourneyService = {

    getCustomerJourney: async (customerId: number): Promise<CustomerJourneyDetail> => {
        const response = await axiosWithAuth.get<CustomerJourneyDetail>(`WelcomeJourney/${customerId}/getcustomerjourney`);
        return response.data;
    },
    updateCustomerjourney: async (customerId: number, journeyStageId: number, completedState: boolean): Promise<CustomerJourneyDetail> => {
        var journeyState: JourneyState = { CompletedState: completedState };
        const response = await axiosWithAuth.put(`WelcomeJourney/${customerId}/journeystage/${journeyStageId}`, journeyState);
        return response.data;
    },
    updateUserJourneyConfigSkipped: async (userid: number): Promise<number> => {
        const response = await axiosWithAuth.put(`WelcomeJourney/${userid}/updatecustomerjourneyconfigskipped`);
        return response.data;
    },
    getRecordingNetworkAccessibility: async (): Promise<RecordingNetworkAccessibilty[]> => {
        const response = await axiosWithAuth.get(`WelcomeJourney/getrecordingnetworkaccessibilty`);
        return response.data;
    },
    getIsLandingPageSeen: async (): Promise<boolean> => {
        const response = await axiosWithAuth.get(`WelcomeJourney/getislandingpageseen`);
        return response.data;
    },
    updateLandingPageSeen: async (): Promise<boolean> => {
        const response = await axiosWithAuth.put(`WelcomeJourney/updatelandingpageseen`);
        return response.data;
    }
};

export default welcomejourneyService;